import { render } from "./TermsOfUse.vue?vue&type=template&id=1785a026&scoped=true&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import "./TermsOfUse.vue?vue&type=style&index=0&id=1785a026&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1785a026"]])

export default __exports__